import type { CPollsTranslations } from "./pl";

/** CPolls - deutsche Übersetzungen (Interaktive Formulare / Umfragen). */
export const de: CPollsTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  list: {
    empty: "Keine Umfragen zum Anzeigen.",
    fillOut: "Ausfüllen",
    showResults: "Ergebnisse",
    alreadyFilled: "Ausgefüllt",
  },
  poll: {
    guestHeading: "Bitte stellen Sie sich zuerst vor",
    labels: {
      email: "E-Mail-Adresse",
      name: "Vorname",
      surname: "Nachname",
      telephone: "Telefon",
      justification: "Begründung der Antwort",
    },
    back: "Zurück zu den Umfragen",
    next: "Weiter",
    end: "Abschließen",
    submitting: "Wird gespeichert...",
    alreadyFilled: "Diese Umfrage wurde von diesem Benutzer bereits ausgefüllt.",
    rankingHint: "Ziehen Sie die Elemente oder nutzen Sie die Pfeile, um die Reihenfolge festzulegen.",
    moveUp: "Nach oben verschieben",
    moveDown: "Nach unten verschieben",
    timeUp: "Die Zeit zum Ausfüllen der Umfrage ist abgelaufen - Ihre Antworten wurden gespeichert.",
    errors: {
      required: "Dieses Feld ist erforderlich.",
      email: "Geben Sie eine gültige E-Mail-Adresse ein.",
      emailTaken: "Diese E-Mail-Adresse ist bereits vergeben.",
      questionRequired: "Eine Antwort auf diese Frage ist erforderlich.",
      submit: "Die Umfrage konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
    },
    nextFill: (date: string): string => `Nächstes Ausfüllen möglich nach ${date}`,
    remainingTime: (time: string): string =>
      `Verbleibende Zeit zum Ausfüllen der Umfrage: ${time}`,
    remainingQuestions: (remaining: number, percent: number): string => {
      const word = Math.abs(remaining) === 1 ? "Frage" : "Fragen";
      return `Verbleibend: ${remaining} ${word} (${percent}%)`;
    },
  },
  completed: {
    thankYou: "Danke für das Ausfüllen der Umfrage !!!",
    showResults: "Ergebnisse ansehen",
    backToList: "Zurück zu den Umfragen",
  },
  score: {
    backToList: "Zurück zu den Umfragen",
    noData: "Keine Ergebnisse zum Anzeigen.",
    votes: "Anzahl der Stimmen",
    percent: "Prozentualer Anteil",
  },
  formatNextFill: (raw: string): string => {
    const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(raw);
    if (!m) return raw;
    return `${m[3]}.${m[2]}.${m[1]} ${m[4]}:${m[5]}`;
  },
};
